//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { type Class, type Doc, type Ref } from '@hcengineering/core'
import { type Employee } from '@hcengineering/contact'
import { type Plugin, plugin } from '@hcengineering/platform'
import { type IssueStatus, type Project } from '@hcengineering/tracker'
import { type Action, type ViewAction } from '@hcengineering/view'
import type { AnyComponent } from '@hcengineering/ui'

/**
 * @public
 * When an issue in `project` transitions to `triggerStatus`, its assignee is set to
 * `newAssignee` (null = unassign). v1 scope: one action (set assignee) per rule, matched by
 * status only -- see server-plugins/automation-resources/OnIssueStatusChange.
 */
export interface AutomationRule extends Doc {
  project: Ref<Project>
  enabled: boolean
  name: string
  triggerStatus: Ref<IssueStatus>
  newAssignee: Ref<Employee> | null
}

/**
 * @public
 */
export const automationId = 'automation' as Plugin

export default plugin(automationId, {
  class: {
    AutomationRule: '' as Ref<Class<AutomationRule>>
  },
  component: {
    AutomationRulesPopup: '' as AnyComponent
  },
  action: {
    OpenAutomationRules: '' as Ref<Action<Doc, any>>
  },
  actionImpl: {
    OpenAutomationRules: '' as ViewAction
  }
})
